const videoListPlayback = {
  state: {
    videoListCacheReturn: new Map(),
    videoCurrentReturnSplit: 4
  },
  mutations: {
    VIDEO_LIST_CACHE_RETURN: (state, { orgId, arr }) => {
      state.videoListCacheReturn.set(orgId, arr)
    },
    VIDEO_CURRENT_RETURN_SPLIT: (state, value) => {
      state.videoCurrentReturnSplit = value
    }
  },
  actions: {
    addVideoCacheReturn({ commit }, { orgId, arr }) {
      commit('VIDEO_LIST_CACHE_RETURN', { orgId, arr })
    },
    setVideoCurrentReturnSplit({ commit }, value) {
      commit('VIDEO_CURRENT_RETURN_SPLIT', value)
    }
  }
}

export default videoListPlayback
